import React from 'react';
import Translate from 'react-translate-component';
import { Button } from 'antd';
import { path } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import CustomIcon from 'components/common/CustomIcon';

export default function ApprovalButtons({ filters, selected, approve, reject, cancel, buttons }) {
    const disabled = !notEmpty(selected);
    const disabledStatus = path(['status'], filters) !== 'inwork';

    return (
        <div className="button-bar">
            { approve &&
                <Button icon={<CustomIcon type='check' />} disabled={disabled} onClick={approve}>
                    <Translate content='button.approve' />
                </Button>
            }
            { reject &&
                <Button icon={<CustomIcon type='close-remove' />} disabled={disabled} onClick={reject}>
                    <Translate content='button.reject' />
                </Button>
            }
            { cancel &&
                <Button icon={<CustomIcon type='close-remove' />} disabled={disabled || disabledStatus} onClick={cancel}>
                    <Translate content='button.cancel' />
                </Button>
            }
            { buttons }
        </div>
    );
}
